module.exports = __webpack_public_path__ + "img/phone_home_v2.04ff5aad.png";